import { ModelBase } from 'store/model-base';

export class ChangeNotificationResult extends ModelBase {
    public static storeName: string = 'changeNotificationResult';

    public notificationRefId: string;
}
